var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	54183: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(494), __webpack_require__.e(8429), __webpack_require__.e(2076), __webpack_require__.e(4087)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 64087))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	24853: {
		fallback: () => (Promise.all([__webpack_require__.e(3440), __webpack_require__.e(4029), __webpack_require__.e(7671)]).then(() => (() => (__webpack_require__(/*! rxjs */ 37671))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	46929: {
		fallback: () => (Promise.all([__webpack_require__.e(3440), __webpack_require__.e(4029), __webpack_require__.e(9029)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 99029))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	96774: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(8046)]).then(() => (() => (__webpack_require__(/*! @angular/common */ 48046))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	62700: {
		fallback: () => (Promise.all([__webpack_require__.e(6774), __webpack_require__.e(5718), __webpack_require__.e(6536), __webpack_require__.e(4581)]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 94581))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	91361: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 65412))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	61985: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 60228))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	38004: {
		fallback: () => (__webpack_require__.e(2215).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 24596))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/bidi",

	},
	32732: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(6774), __webpack_require__.e(2076), __webpack_require__.e(3797)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 22164))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	},
	42848: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(6774), __webpack_require__.e(2700), __webpack_require__.e(7966), __webpack_require__.e(4548)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 47234))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",

	},
	38696: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(1849)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 29354))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/coercion",

	},
	78756: {
		fallback: () => (Promise.all([__webpack_require__.e(6774), __webpack_require__.e(2076), __webpack_require__.e(6894)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 21543))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/platform",

	},
	46562: {
		fallback: () => (__webpack_require__.e(6772).then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 34391))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/private",

	},
	35960: {
		fallback: () => (__webpack_require__.e(459).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 50459))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/keycodes",

	},
	50126: {
		fallback: () => (Promise.all([__webpack_require__.e(6774), __webpack_require__.e(5411)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 95411))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",

	},
	22320: {
		fallback: () => (__webpack_require__.e(4788).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 94788))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",

	},
	90932: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 7949))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers/private",

	},
	21939: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(6774), __webpack_require__.e(5117)]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 15117))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	48360: {
		fallback: () => (Promise.all([__webpack_require__.e(6774), __webpack_require__.e(5411), __webpack_require__.e(4788), __webpack_require__.e(2956), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 89126))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",

	},
	62240: {
		fallback: () => (Promise.all([__webpack_require__.e(6774), __webpack_require__.e(5411), __webpack_require__.e(2700), __webpack_require__.e(4788), __webpack_require__.e(2956), __webpack_require__.e(7966), __webpack_require__.e(4454)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 94454))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/dialog",

	},
	9390: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(5457)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 65457))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/collections",

	},
	86288: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(4139)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 41888))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/accordion",

	},
	3210: {
		fallback: () => (__webpack_require__.e(5508).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 63127))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers",

	},
	6536: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(7421)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 37421))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	25708: {
		fallback: () => (__webpack_require__.e(5984).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 75984))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/text-field",

	},
	73376: {
		fallback: () => (Promise.all([__webpack_require__.e(6929), __webpack_require__.e(6774), __webpack_require__.e(5411), __webpack_require__.e(6050)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/table */ 56050))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/table",

	},
	86581: {
		fallback: () => (__webpack_require__.e(9880).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 59880))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	31806: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(6774), __webpack_require__.e(2700), __webpack_require__.e(2444)]).then(() => (() => (__webpack_require__(/*! @angular/router */ 12444))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	27715: {
		fallback: () => (__webpack_require__.e(3300).then(() => (() => (__webpack_require__(/*! @ngrx/signals */ 83300))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals",

	},
	93656: {
		fallback: () => (__webpack_require__.e(2441).then(() => (() => (__webpack_require__(/*! moment */ 52441))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.24.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "moment",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"126": [
		50126
	],
	"932": [
		90932
	],
	"1939": [
		21939
	],
	"2320": [
		22320
	],
	"2336": [
		31806,
		27715
	],
	"2700": [
		62700
	],
	"2732": [
		32732
	],
	"2848": [
		42848
	],
	"3210": [
		3210
	],
	"3376": [
		73376
	],
	"3656": [
		93656
	],
	"3758": [
		62240
	],
	"4183": [
		54183
	],
	"4853": [
		24853
	],
	"4993": [
		86288
	],
	"5708": [
		25708
	],
	"5960": [
		35960
	],
	"6536": [
		6536
	],
	"6562": [
		46562
	],
	"6581": [
		86581
	],
	"6774": [
		96774
	],
	"6929": [
		46929
	],
	"8004": [
		38004
	],
	"8360": [
		48360
	],
	"8429": [
		91361,
		61985
	],
	"8696": [
		38696
	],
	"8756": [
		78756
	],
	"9390": [
		9390
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}